'use client';

import { usePathname } from 'next/navigation';
import LanguageSelector from '@/app/components/LanguageSelector';
import { routing } from '@/i18n/routing';

/**
 * Global language control for non-landing routes.
 * Landing embeds language next to brand to keep one composition.
 */
export default function GlobalLanguageChrome() {
  const pathname = usePathname();
  const isLanding = routing.locales.some(
    (locale) => pathname === `/${locale}` || pathname === `/${locale}/`
  );
  const isAuth =
    /\/(register|login|verify|recovery|update-password|auth)\b/.test(
      String(pathname || '')
    );
  const isDashboardHub = routing.locales.some(
    (locale) =>
      pathname === `/${locale}/dashboard` || pathname === `/${locale}/dashboard/`
  );

  // Hub embeds language in its sticky nav; elsewhere keep a compact control on the right.
  if (isLanding || isAuth || isDashboardHub) return null;

  return (
    <div className="fixed top-3 right-3 z-[100] sm:right-4">
      <LanguageSelector />
    </div>
  );
}
